export default "__VITE_ASSET__28be0bb7__"